module.exports = __webpack_public_path__ + "media/images/subject_img/SOCIOLOGY-ef1448b06bc84c94018d05e66258536c.jpg";